/*
This is the config / PDF DOM that is used by the PDFCreator.
It is created by the PDFModel, and sent to the PDFCreator in the PDFDownload component.
This is the 'view/template' that defines the PDF that is created by the PDFCreator.

Styles/layout/config all done (for now) in pdfStyle.config.js
*/
import _ from 'lodash';
import titlePage from './PDFTitlePage';
import introduction from './PDFIntroduction';
import demographics from './PDFDemographics';
import conclusion from './PDFConclusion';
import categoryTitlePage from './PDFCategoryTitlePage';
import pdfFooter from './PDFFooter';
import sectionPage from './PDFSectionPage';
import references from './PDFReferences';

/* eslint-disable no-param-reassign */
const pdfSectionPages = {
    demographics: (printSection) => {
        // console.log('printSection', printSection);
        printSection.printMetrics.education.position = 'col-2';
        printSection.printMetrics['pct-immigrants-arrved-last-five-yrs'].position = 'col-2';
        printSection.printMetrics['population-age-gender'].position = 'col-1';
        printSection.printMetrics['population-growth'].position = 'col-1';
        return sectionPage(printSection, { metrics: { mt: 58 } });
    },
    // econimicEnvironment: (printSection) => {
    //     return sectionPage(printSection, { metrics: { metricsPerCol: printSection.printMetrics.length / 2 } });
    // },
    mentalHealth: (printSection) => {
        // console.log('Mental Health metrics', printSection.printMetrics);
        // printSection.printMetrics['gen-07'].h = 'h-2-1/2';
        // printSection.printMetrics['eq-5-d-q-5'].h = 'h-2-1/2';
        // console.log('Mental Health metrics', printSection.printMetrics.stress2);
        // printSection.printMetrics['stress-2'].h = 'h-2-7/8';
        const template = sectionPage(
            printSection,
            {
                description: { y: 'h-1-5/8', font: 'background' },
                metrics: { mt: 55, metricsPerCol: 2 },
                links: { position: 'col-2', y: 'h-11-1/2' }
            }
        );

        return template;
    },
    tobacco: (printSection) => {
        printSection.printMetrics['smoke-8-cpdv'].position = 'col-2';
        printSection.printMetrics['smoke-9-cpdv'].position = 'col-2';
        return sectionPage(printSection);
        // const content = { y: 'h-10' };
        // const primaryMetric = { position: 'col-1', y: 'h-12' };
        // return sectionPage(printSection, { primaryMetric, content, metrics: { y: 'h-3', metricsPerCol: 4 } });
    },
    immunization: (printSection) => sectionPage(printSection, { metrics: { metricsPerCol: 2 } }),
    healthyEating: (printSection) => sectionPage(printSection, { metrics: { metricsPerCol: 3 } }),
    uvr: (printSection) => sectionPage(printSection, { metrics: { metricsPerCol: 2 } }),
    alcohol: (printSection) => {
        // console.log('alcohol metrics', printSection.printMetrics);
        printSection.printMetrics['alw-2-a-1-cpdv'].position = 'col-2';
        printSection.printMetrics['alc-1-cpdv'].position = 'col-2';
        return sectionPage(printSection, { metrics: { metricsPerCol: 2 } });
    },
    physicalActivity: (printSection) => {
        // console.log('physicalActivity metrics', printSection.printMetrics);
        // console.log('physicalActivity metrics', printSection.printMetrics['cal-activity']);
        // console.log('physicalActivity metrics', printSection.printMetrics['pa-strn']);
        // printSection.printMetrics['cal-activity'].h = 'h-3';
        printSection.printMetrics['pa-strn-cpdv'].position = 'col-2';
        // printSection.printMetrics['pa-strn'].h = 'h-3-1/2';
        return sectionPage(printSection, { metrics: { metricsPerCol: 3 } });
    },
    accessToHealthServices: (printSection) => {
        const page = sectionPage(
            printSection,
            {
                metrics: { metricsPerCol: 2 },
                content: { y: 'h-5' }
            }
        );
        const image = printSection.options.image;
        page.image = {
            position: 'parent',
            src: image.src,
            y: 'h-8-3/4',
            h: image.height,
            w: image.width
        };
        return page;
    },
    physicalEnvironment: (printSection) => {
        // _.mapValues(printSection.printMetrics, (metric) => {
        //     metric.h = 'h-3-3/4';
        //     return metric;
        // });
        const page = sectionPage(printSection, { content: { y: 'h-7' }, metrics: { metricsPerCol: 2 } });
        const image = printSection.options.image;
        page.image = {
            position: 'parent',
            src: image.src,
            y: 'h-10-3/4',
            h: image.height,
            w: image.width
        };
        return page;
    },
    cancerScreening: (printSection) => {
        // console.log('Cancer metrics', printSection, printSection.printMetrics, printSection.primaryMetric);
        printSection.printMetrics['colorectal-cancer-screening-rate-50-74'].position = 'col-2';
        return sectionPage(printSection, { content: { y: 'h-9-1/2' } });
    },
    qualityOfHealth: (printSection) => {
        _.mapValues(printSection.printMetrics, (metric) => {
            metric.position = 'col-2';
            return metric;
        });
        return sectionPage(printSection, { metrics: { mt: 250 } });
    }
};
const print = true;
// Decorates the metrics with properties that allow them to be toggled on and off
// by the PDF Creator
const makeSectionMetricsOptional = (section) => {
    const { printMetrics } = section;
    return _.mapValues(printMetrics, (metric, key) => {
        metric.print = true;
        return {
            id: key,
            optional: true,
            get print() { return metric.print; },
            set print(v) { metric.print = v; },
            title: metric.shortLabel
        };
    });
};

/* eslint-enable no-param-reassign */
const pdfSections = ({ printSections }, { footer, newPage = true }) => _.mapValues(printSections, (section) => {
    const pdfSectionPage = pdfSectionPages[section.id] || sectionPage;
    const optionalMetrics = makeSectionMetricsOptional(section);
    return {
        title: section.title,
        print,
        optional: newPage,
        newPage,
        // sections here refers to the sections within a page that can be toggled by a user.
        sections: optionalMetrics,
        page: () => pdfSectionPage(section),
        footer: newPage && footer
    };
});

const pdfCategoryPages = {
    demographics,
    livingConditions: (printCategory) => categoryTitlePage(printCategory, { image: printCategory.image }),
    healthBehaviours: (printCategory) => categoryTitlePage(printCategory, { image: printCategory.image }),
    mentalHealth: (printCategory) => categoryTitlePage(printCategory, { h: 300, title: { w: 400 } }),
    healthWellbeing: (printCategory) => categoryTitlePage(
        printCategory,
        {
            h: 'h-4-1/2',
            image: {
                src: printCategory.image.src,
                position: 'col-1',
                y: 'h-4',
                w: printCategory.image.width,
                h: printCategory.image.height
            }
        }
    ),
    conclusion
};

const pdfCategory = (printCategory, { footer, optional = true, debug }) => {
    // console.log('Print Category', printCategory);
    const pdfCategoryPage = pdfCategoryPages[printCategory.id] || categoryTitlePage;
    return {
        optional,
        print,
        title: printCategory.title,
        container: true,
        content: {
            newPage: true,
            debug,
            title: printCategory.title,
            page: () => pdfCategoryPage(printCategory),
            footer
        }
    };
};

export default class PDFDocument {
    constructor(model) {
        this.model = model;
        this.references = references;
    }

    reset() {
        this.references.reset(this.model);
    }

    // The document itself starts here.
    // Every document needs exactly 1 root node
    // Every node can have properties: title, newPage, optional, container, debug
    // NOTE: Must set container = true for the node to have children, otherwise it is a leaf node
    // Every non-container object / function in the node will be rendered as a leaf node.
    get root() {
        const footer = pdfFooter(this.model);
        const backgroundFooter = ({ num }) => footer({ num, font: 'background' });
        const printCategories = this.model.printCategories;
        const root = {
            titlePage: {
                title: 'Title Page',
                page: () => titlePage(this.model.titlePageModel)
            },
            intro: {
                newPage: true,
                // debug: true,
                title: 'Introduction',
                page: (node, creator) => introduction(this.model.introPageModel, creator)
            },
            demographics: {
                showChildren: false,
                ...pdfCategory(printCategories.demographics, { footer, debug: false }),
                ...pdfSections(printCategories.demographics, { newPage: false })
            },
            livingConditions: {
                ...pdfCategory(printCategories.livingConditions, { footer: backgroundFooter }),
                ...pdfSections(printCategories.livingConditions, { footer })
            },
            mentalHealth: {
                showChildren: false,
                ...pdfCategory(printCategories.mentalHealth, { footer }),
                ...pdfSections(printCategories.mentalHealth, { newPage: false })
            },
            healthBehaviours: {
                ...pdfCategory(printCategories.healthBehaviours, { footer: backgroundFooter }),
                ...pdfSections(printCategories.healthBehaviours, { footer })
            },
            healthWellbeing: {
                showChildren: false,
                ...pdfCategory(printCategories.healthWellbeing, { footer }),
                ...pdfSections(printCategories.healthWellbeing, { newPage: false })
            },
            conclusion: {
                ...pdfCategory(printCategories.conclusion, { footer })
            },
            references: this.references.page
        };
        // console.log('references: ', this.references, this.references.pageNumber);
        return root;
        // return { titlePage: root.titlePage, demographics: root.demographics, livingConditions: root.livingConditions };
    }
}
